var map = {
	"./chameleon-theme-az/lib/styleguide/tokens.js.json": "puA3",
	"./chameleon-theme-beltel/lib/styleguide/tokens.js.json": "FVY9",
	"./chameleon-theme-co/lib/styleguide/tokens.js.json": "JZJp",
	"./chameleon-theme-dl/lib/styleguide/tokens.js.json": "nvPk",
	"./chameleon-theme-ds/lib/styleguide/tokens.js.json": "NwMf",
	"./chameleon-theme-ge/lib/styleguide/tokens.js.json": "fxLB",
	"./chameleon-theme-gva/lib/styleguide/tokens.js.json": "Ia8L",
	"./chameleon-theme-hbvl/lib/styleguide/tokens.js.json": "7Gmk",
	"./chameleon-theme-hd/lib/styleguide/tokens.js.json": "p2QY",
	"./chameleon-theme-hub/lib/styleguide/tokens.js.json": "w3UR",
	"./chameleon-theme-indo/lib/styleguide/tokens.js.json": "HAHz",
	"./chameleon-theme-ld/lib/styleguide/tokens.js.json": "1fo4",
	"./chameleon-theme-lt/lib/styleguide/tokens.js.json": "2NDP",
	"./chameleon-theme-lw/lib/styleguide/tokens.js.json": "F0pK",
	"./chameleon-theme-mh/lib/styleguide/tokens.js.json": "FhnL",
	"./chameleon-theme-nb-legacy/lib/styleguide/tokens.js.json": "wfdv",
	"./chameleon-theme-nb/lib/styleguide/tokens.js.json": "Lg3Z",
	"./chameleon-theme-nhd/lib/styleguide/tokens.js.json": "QTLw",
	"./chameleon-theme-sw/lib/styleguide/tokens.js.json": "Ku5l",
	"./chameleon-theme-tc/lib/styleguide/tokens.js.json": "qrzf",
	"./chameleon-theme-tel/lib/styleguide/tokens.js.json": "tKFS",
	"./chameleon-theme-vl/lib/styleguide/tokens.js.json": "DKIy",
	"./chameleon-theme-wl/lib/styleguide/tokens.js.json": "GTDs",
	"./chameleon-theme-yc/lib/styleguide/tokens.js.json": "8jYp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Yn2R";